import React from 'react';
import { Box, makeStyles, Typography } from 'housecall-ui';

import ConfirmationElementsList from '../components/ConfirmationElementsList';
import { ScrollableContent } from '../components/ScrollableContent';
import { SelectedServiceHeader } from '../components/SelectedServiceHeader';

const useStyles = makeStyles(() => ({
  container: {
    overflowWrap: 'break-word',
  },
}));

export const ConfirmBookingStep = () => {
  const styles = useStyles();

  return (
    <>
      <SelectedServiceHeader />
      <Typography gutterBottom variant="h5">
        Booking confirmation
      </Typography>
      <ScrollableContent>
        <Box my={2} className={styles.container}>
          <ConfirmationElementsList />
        </Box>
      </ScrollableContent>
    </>
  );
};
